const booleanFilter = {
  defaultOption: "all",
  filterOptions: [
    {
      displayKey: "all",
      displayName: "Todos",
      predicate: () => true,
      numberOfInputs: 0
    },
    {
      displayKey: "true",
      displayName: "Si",
      predicate: (_, cellValue) => +cellValue === 1,
      numberOfInputs: 0
    },
    {
      displayKey: "false",
      displayName: "No",
      predicate: (_, cellValue) => +cellValue === 0,
      numberOfInputs: 0
    }
  ],
  suppressAndOrCondition: true
};

const dateFilter = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    if (cellValue == null) return -1;
    var cellDate = new Date(new Date(cellValue).setHours(24, 0, 0, 0));
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) return 0;
    if (cellDate < filterLocalDateAtMidnight) return -1;
    if (cellDate > filterLocalDateAtMidnight) return 1;
    return 0;
  },
  minValidYear: 2000,
  maxValidYear: 2035,
  inRangeFloatingFilterDateFormat: "Do MMM YYYY"
};

export { booleanFilter, dateFilter };
